// Single source of truth for the app version. Bump it here only — the
// environment files and everything that displays or reports the version
// read it from this file.
export const APP_VERSION = '1.21.148';
